<template>
  <div class="content" v-if="isShow">
    <div class="headerarea">
      <Header></Header>
    </div>
    <div>
      <Nav></Nav>
    </div>
    <div class="corearea">
      <router-view :key="Math.random()" />
    </div>
    <div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from './index/Header.vue'
import Footer from './index/Footer.vue'
import Nav from './index/Nav.vue'

import { getFindAll, getFindPage } from '../request/get'

const rate= window.outerWidth/1230;
export default {
  metaInfo: {
    title: '佰标技术服务网',
    meta: [
      { name:'viewport', content:
      `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
    ]
  },
  name: "index",
  components: {
    Header,
    Nav,
    Footer
  },
  data() {
    return {
    }
  },
  computed: {
    isShow() {
      return this.$store.getters.isShow;
    }
  },
  created() {
    this.getFindAll();
    this.getFindPage();
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function(event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    async getFindAll() {
      let result = await getFindAll();
      result = result.data[0] || null;
      this.$store.dispatch("SET_WEBCONFIG", result);
    },
    async getFindPage() {
      let result = await getFindPage();
      result = result.data || [];
      this.$store.dispatch("SET_PLATES", result)
    }
  }
};
</script>
<style scoped>
.content{
  position: relative;
  height: 100%;
  background-image: url(/static/img/bg_bioazhun.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-color: #ffffff;
}
.headerarea{
  position: relative;
  width: 1200px;
  margin: 0 auto;
}
.corearea{
  position: relative;
  width: 100%;
  margin: 0 auto;
}
</style>
